/* ==========================================================================
   ProductCardSmall > Client > Config
   ========================================================================== */

/* Modules */

/* Config */
const config = {
    component: 'ProductCardSmall',
    image: {
        size: {
            height: 190,
            width: 348
        }
    }
};

/* Exports */
module.exports = () => config;
